import { render, staticRenderFns } from "./PrinterLocations.vue?vue&type=template&id=5f829c6a&scoped=true&"
import script from "./PrinterLocations.vue?vue&type=script&lang=js&"
export * from "./PrinterLocations.vue?vue&type=script&lang=js&"
import style0 from "./PrinterLocations.vue?vue&type=style&index=0&id=5f829c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f829c6a",
  null
  
)

export default component.exports